module.exports = __webpack_public_path__ + "img/img22.c2798b7d.svg";